// @ts-nocheck
import { Field } from "react-final-form";
import { TitlePage, PhoneField, CheckboxField } from "~/components";
import { composeValidators, disabledValidate, required, testRegExp } from "~/utils/validate";
import { Divider } from "antd";
import { Wizard, FormField, GetCrmSocialLinksTitle } from "~/pages/questionnaires/shared";
import { NamesOfFieldEnum } from "~/typings/types";
import { configTitleFieldsOfCompany } from "../configTitleFields";

import styles from "~/pages/questionnaires/shared/Shared.module.scss";

export const AccountDetails = () => {
  return (
    <Wizard.Page>
      <TitlePage
        name="Укажите ваши данные для регистрации аккаунта в системе Prodamus"
        number="2"
        description="Если у вас есть технический специалист, необходимо указать его контактные данные на шаге 4 в поле «Контакты технического специалиста». Если вы сами выполняете роль технического специалиста, укажите свои данные."
      />
      <Divider style={{ margin: 0 }} />
      <div className={styles.container}>
        <FormField
          titleField={configTitleFieldsOfCompany[NamesOfFieldEnum.CrmName]}
          name={NamesOfFieldEnum.CrmName}
          required
          validate={composeValidators(required())}
        />

        <FormField
          titleField={configTitleFieldsOfCompany[NamesOfFieldEnum.CrmPhone]}
          name={NamesOfFieldEnum.CrmPhone}
          required
        >
          <Field
            titleField={configTitleFieldsOfCompany[NamesOfFieldEnum.CrmName]}
            name={NamesOfFieldEnum.CrmPhone}
            subscription={{ submitFailed: true, error: true, submitError: true, value: true }}
            validate={disabledValidate(composeValidators(required()))}
            component={props => <PhoneField  {...props} />}
          />
        </FormField>

        <FormField
          titleField={configTitleFieldsOfCompany[NamesOfFieldEnum.CrmEmail]}
          name={NamesOfFieldEnum.CrmEmail}
          required
          validate={composeValidators(
            required(),
            testRegExp(
              /^\s*\S+@\S+\.\S+\s*$/,
              "Пожалуйста, укажите корректный адрес электронной почты"
            )
          )}
        />

        <FormField
          titleField={configTitleFieldsOfCompany[NamesOfFieldEnum.CrmSocialLinks]}
          name={NamesOfFieldEnum.CrmSocialLinks}
        />

      </div>
    </Wizard.Page>
  );
};
